import { __awaiter, __extends, __generator } from "tslib";
import { StratusClient } from '../stratus-client';
/**
 * Client for making Customer Management Service API calls.
 */
var TenantMgtSvcClient = /** @class */ (function (_super) {
    __extends(TenantMgtSvcClient, _super);
    function TenantMgtSvcClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apiName = 'ws-hp.com/tenantmgtsvc';
        _this.apiVersion = '2';
        _this.tenantsEndpoint = '/tenants';
        return _this;
    }
    /**
     * Get a Customers/Tenants list on behalf of the authenticated user.
     * @param {GetTenantListOptions} options options for getting Tenantlists
     * @returns Axios response object
     */
    TenantMgtSvcClient.prototype.getTenantList = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        url: this.tenantsEndpoint,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-HTTP-Method-Override': 'GET',
                        },
                        data: this._parseOptions(options),
                    })];
            });
        });
    };
    TenantMgtSvcClient.prototype._parseOptions = function (options) {
        var data = {
            startIndex: options.startIndex,
            maxResultSetSize: options.maxResultSetSize,
            criterionList: [
                {
                    propertyName: options.propertyName,
                    propertyDataType: options.propertyDataType,
                    propertyValue: options.propertyValue,
                    operation: options.operation,
                },
            ],
        };
        return data;
    };
    /**
     * Retrives Tenant/Customer Details
     * @param {string} id A Customer Resource ID
     * @returns Axios response object
     */
    TenantMgtSvcClient.prototype.getTenantDetails = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.tenantsEndpoint, "/").concat(id),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            });
        });
    };
    return TenantMgtSvcClient;
}(StratusClient));
export { TenantMgtSvcClient };
//# sourceMappingURL=tenant-mgt-svc.js.map